import { inheritsLoose as _inheritsLoose } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

var SpinningCircle = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SpinningCircle, _Component);
  function SpinningCircle(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this._spinCircle = function (timestamp) {
      if (!_this._stop) {
        if (!_this._start) {
          _this._start = timestamp;
        }
        var progress = timestamp - _this._start;
        // eslint-disable-next-line zillow/react/no-access-state-in-setstate
        var c = _this.state.circleCircumference;
        _this.setState({
          // Moving from 0 and c, every period
          strokeDashoffset: progress / _this.props.period * c % c
        });

        // eslint-disable-next-line no-undef
        window.requestAnimationFrame(_this._spinCircle);
      }
    };
    var r = props.r;
    var _c = Math.PI * r * 2;
    _this.state = {
      circleRadius: r,
      circleCircumference: _c,
      strokeDasharray: _c / (props.arcs * 2),
      strokeDashoffset: 2
    };
    return _this;
  }
  var _proto = SpinningCircle.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this._start = null;
    this._stop = null;

    // eslint-disable-next-line no-undef
    if (window.requestAnimationFrame) {
      // eslint-disable-next-line no-undef
      window.requestAnimationFrame(this._spinCircle);
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this._stop = true;
  };
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("circle", {
      cx: this.props.cx,
      cy: this.props.cy,
      r: this.state.circleRadius,
      fill: "transparent",
      stroke: this.props.color || this.props.theme.constellation.colors.blue500,
      strokeWidth: this.props.strokeWidth,
      strokeDasharray: this.state.strokeDasharray,
      style: {
        strokeDashoffset: this.state.strokeDashoffset
      }
    });
  };
  return SpinningCircle;
}(Component);
SpinningCircle.defaultProps = {
  // eslint-disable-next-line zillow/react/default-props-match-prop-types
  className: 'rd3-linechart-spinning-circle',
  r: 10,
  strokeWidth: '3px',
  arcs: 8,
  period: 2000
};
SpinningCircle.propTypes = process.env.NODE_ENV !== "production" ? {
  cx: PropTypes.number,
  cy: PropTypes.number,
  color: PropTypes.string,
  r: PropTypes.number,
  // In px
  strokeWidth: PropTypes.string,
  arcs: PropTypes.number,
  period: PropTypes.number,
  // ms between full rotations
  // eslint-disable-next-line zillow/react/forbid-prop-types
  theme: PropTypes.object
} : {};
var SpinningCircle$1 = withTheme(SpinningCircle);

export { SpinningCircle$1 as default };
